import { render } from "./SizeRangeInputs.vue?vue&type=template&id=7056a66e&scoped=true"
import script from "./SizeRangeInputs.vue?vue&type=script&lang=js"
export * from "./SizeRangeInputs.vue?vue&type=script&lang=js"

import "./SizeRangeInputs.vue?vue&type=style&index=0&id=7056a66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7056a66e"]])

export default __exports__